"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottleUnit = exports.TimeUnit = exports.WeightUnit = exports.VolumeUnit = exports.MeasurementUnit = exports.UnitType = void 0;
var UnitType;
(function (UnitType) {
    UnitType[UnitType["Pieces"] = 0] = "Pieces";
    UnitType[UnitType["Weight"] = 1] = "Weight";
    UnitType[UnitType["Volume"] = 2] = "Volume";
    UnitType[UnitType["Time"] = 3] = "Time";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
/**
 * @deprecated Use VolumeUnit & WeightUnit instead
 */
var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["Kilogram"] = "kg";
    MeasurementUnit["Centiliter"] = "cl";
})(MeasurementUnit = exports.MeasurementUnit || (exports.MeasurementUnit = {}));
var VolumeUnit;
(function (VolumeUnit) {
    VolumeUnit["Centiliter"] = "cl";
})(VolumeUnit = exports.VolumeUnit || (exports.VolumeUnit = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["Kilogram"] = "kg";
    WeightUnit["Gram"] = "g";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Hours"] = "h";
    TimeUnit["Minutes"] = "m";
    TimeUnit["MinutesShorthand"] = "mins";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var BottleUnit;
(function (BottleUnit) {
    BottleUnit["Bottle"] = "bottle";
    BottleUnit["Glass"] = "glass";
})(BottleUnit = exports.BottleUnit || (exports.BottleUnit = {}));
